import { render, staticRenderFns } from "./PrescriptionForm.vue?vue&type=template&id=401ee4ac&scoped=true&"
import script from "./PrescriptionForm.vue?vue&type=script&lang=js&"
export * from "./PrescriptionForm.vue?vue&type=script&lang=js&"
import style0 from "./PrescriptionForm.vue?vue&type=style&index=0&id=401ee4ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401ee4ac",
  null
  
)

export default component.exports